import { StatusChip } from "@/components/shared/status-chip";

/**
 * Marks a demand that is a resale: revenue, a matching purchase, and nobody's
 * time in between.
 *
 * It exists because the 55% services benchmark does not apply to reselling a
 * licence at cost, and no lever moves it -- so a resale sitting at the top of
 * an account's "below benchmark" list is information, not an action. Labelled
 * rather than dropped: the money is real and belongs in the total.
 */
export function ResaleBadge({ className }: { className?: string }) {
  return (
    <StatusChip
      tone="neutral"
      className={className}
      title="Resale: revenue with a matching purchase and no delivery time. The services benchmark does not apply."
    >
      Resale
    </StatusChip>
  );
}
